module.exports = __webpack_public_path__ + "img/PD1505105753420201984.f35fb33d.png";